import { usePaginatedQuery } from 'react-query'
import { Pagination } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import { useState, useEffect } from 'react'

const useApiWithInfiniteScroll = (
    queryKey,
    queryFn,
    queryConfig,
    defaultTake = 15,
    paginationProps,
    showCount = true,
) => {
    const [{ page }, dispatch] = usePageContext()
    const [take, setTake] = useState(defaultTake)
    let minimumRowsPerPage

    // Add this effect to update take when defaultTake changes
    useEffect(() => {
        setTake(defaultTake)
    }, [defaultTake])

    const handlePageChange = (_, value) => {
        dispatch({
            type: 'SET_PAGE',
            payload: value,
        })
    }

    const handlePageSelection = (value) => {
        dispatch({
            type: 'SET_PAGE',
            payload: value,
        })
    }

    const handleItemsPerPageChange = (value) => {
        dispatch({
            type: 'SET_PAGE',
            payload: 1,
        })
        setTake(value)
    }

    const skip = (page - 1) * take

    const {
        latestData,
        error,
        refetch,
        isLoading: isInitialLoading,
    } = usePaginatedQuery(
        [...queryKey, skip, take],
        () => queryFn(skip, take),
        queryConfig,
    )

    const isLoading = !Boolean(latestData)

    const numberOfPages = latestData
        ? Math.ceil(latestData.totalCount / take)
        : 0

    if (defaultTake < 10) {
        minimumRowsPerPage = defaultTake
    }

    const pagination = (
        <Pagination
            count={numberOfPages}
            size="large"
            page={page}
            onChange={handlePageChange}
            showPageSelection={true}
            onPageSelection={handlePageSelection}
            itemsPerPage={take}
            showItemsPerPageSelection={true}
            onItemsPerPageChange={handleItemsPerPageChange}
            parentIndex={9}
            minimumRowsPerPage={minimumRowsPerPage}
            totalCount={latestData?.totalCount}
            showCountStat={showCount}
            {...paginationProps}
        />
    )

    return {
        loading: isLoading,
        list: latestData ? latestData.data : undefined,
        totalCount: latestData ? latestData.totalCount : undefined,
        rest: latestData ? latestData : undefined,
        pagination,
        error,
        refetch,
        isInitialLoading,
    }
}

export default useApiWithInfiniteScroll
